function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.236 5h5.267v2.983l-2.635 3.282h.835l1.8 2.244v2.982h-5.267V13.51l2.216-2.764-2.216-2.762V5zm3.752 3.83l.857-1.067V5.64h-3.95v2.124l.855 1.068h2.238zm-.038 3.782l-1.08-1.347-1.08 1.347h2.16zM22.15 19.854l3.94 3.563 2.816.52c-.082.426-.462.765-.89.773H10.063c-.847 0-1.53-.666-1.53-1.487v-.687l.993-1.26a5.514 5.514 0 013.091.288l2.295.31h2.028l4.2-2.191a.893.893 0 01.886.08l.009.006.01.008.019.013a.693.693 0 01.062.047c.008.005.016.01.023.017zm-2.083 3.023l.091.092 1.318-.405 1.227.227-.657-.376a.893.893 0 01-.188-.135l-.509-.46-.066.056-.5.421h-.001l-.715.58z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.566 22.253a1.324 1.324 0 01-.274-1.893c.45-.581 1.292-.71 1.903-.302l.048.036 1.08.789c.28.202.334.585.124.855l-.431.553c-.328-.151-.578-.107-.895.042-.516.245-1.088.261-1.555-.08z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.948 24.71H4.736c-.91 0-1.642-.713-1.642-1.591v-2.442l1.265 1.227c.182.177.276.337.289.627v1.095h.079l.215-.422h2.025c.54 0 .981.427.981.953v.553zM2 27.424c0 .318.258.576.576.576h26.848a.575.575 0 100-1.151H2.576a.576.576 0 00-.576.575z",
  fill: "currentColor"
})));